import { createStore } from 'effector';

import { Message } from 'models/Chat/Chat';

export const $messages = createStore<Message[]>([]);

export const $answer = createStore<string>('');
